import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 建立第 1 版。不送 updated_at。 */
export async function createInspectionKind(payload) {
  const body = keysToSnake(payload);
  delete body.updated_at;
  const { data: raw } = await request.post('/ims/inspection-kinds', body);
  return parseVer4DetailResponse(raw);
}
